import { combineReducers } from 'redux';

import wzap_api_oficial from './wzap_api_oficial/reducers'
import facebook from './facebook/reducers'

export default combineReducers({
    wzap_api_oficial,
    facebook
});